/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type VehicleTableServiceBreakLocationFilterQueryVariables = Types.Exact<{
  input: Types.ServiceBreakLocationsInput
}>

export type VehicleTableServiceBreakLocationFilterQuery = {
  __typename?: 'Query'
  serviceBreakLocations: {
    __typename?: 'ServiceBreakLocationsResponse'
    serviceBreakLocations: Array<{
      __typename?: 'ServiceBreakLocation'
      id: string
      name: string
    }>
  }
}

export const VehicleTableServiceBreakLocationFilterDocument = gql`
    query vehicleTableServiceBreakLocationFilter($input: ServiceBreakLocationsInput!) {
  serviceBreakLocations(input: $input) {
    serviceBreakLocations {
      id
      name
    }
  }
}
    `

/**
 * __useVehicleTableServiceBreakLocationFilterQuery__
 *
 * To run a query within a React component, call `useVehicleTableServiceBreakLocationFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleTableServiceBreakLocationFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleTableServiceBreakLocationFilterQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVehicleTableServiceBreakLocationFilterQuery(
  baseOptions: Apollo.QueryHookOptions<
    VehicleTableServiceBreakLocationFilterQuery,
    VehicleTableServiceBreakLocationFilterQueryVariables
  > &
    (
      | {
          variables: VehicleTableServiceBreakLocationFilterQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VehicleTableServiceBreakLocationFilterQuery,
    VehicleTableServiceBreakLocationFilterQueryVariables
  >(VehicleTableServiceBreakLocationFilterDocument, options)
}
export function useVehicleTableServiceBreakLocationFilterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VehicleTableServiceBreakLocationFilterQuery,
    VehicleTableServiceBreakLocationFilterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VehicleTableServiceBreakLocationFilterQuery,
    VehicleTableServiceBreakLocationFilterQueryVariables
  >(VehicleTableServiceBreakLocationFilterDocument, options)
}
// @ts-ignore
export function useVehicleTableServiceBreakLocationFilterSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VehicleTableServiceBreakLocationFilterQuery,
    VehicleTableServiceBreakLocationFilterQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  VehicleTableServiceBreakLocationFilterQuery,
  VehicleTableServiceBreakLocationFilterQueryVariables
>
export function useVehicleTableServiceBreakLocationFilterSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VehicleTableServiceBreakLocationFilterQuery,
        VehicleTableServiceBreakLocationFilterQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  VehicleTableServiceBreakLocationFilterQuery | undefined,
  VehicleTableServiceBreakLocationFilterQueryVariables
>
export function useVehicleTableServiceBreakLocationFilterSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VehicleTableServiceBreakLocationFilterQuery,
        VehicleTableServiceBreakLocationFilterQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    VehicleTableServiceBreakLocationFilterQuery,
    VehicleTableServiceBreakLocationFilterQueryVariables
  >(VehicleTableServiceBreakLocationFilterDocument, options)
}
export type VehicleTableServiceBreakLocationFilterQueryHookResult = ReturnType<
  typeof useVehicleTableServiceBreakLocationFilterQuery
>
export type VehicleTableServiceBreakLocationFilterLazyQueryHookResult =
  ReturnType<typeof useVehicleTableServiceBreakLocationFilterLazyQuery>
export type VehicleTableServiceBreakLocationFilterSuspenseQueryHookResult =
  ReturnType<typeof useVehicleTableServiceBreakLocationFilterSuspenseQuery>
export type VehicleTableServiceBreakLocationFilterQueryResult =
  Apollo.QueryResult<
    VehicleTableServiceBreakLocationFilterQuery,
    VehicleTableServiceBreakLocationFilterQueryVariables
  >
